/* global translation */

const mobileMenu = document.getElementById('mobile-menu');
if (mobileMenu) {
  Array.from(mobileMenu.querySelectorAll('.large ul.menu > li > ul > li')).forEach((li) => {
    const toggleSubMenu = document.createElement('button');
    const menuLink = li.querySelector('a');
    const clonedMenuLink = menuLink.cloneNode(true);
    toggleSubMenu.className = 'mobile-toggle-sub-menu';
    toggleSubMenu.innerText = '+';
    const categoryName = clonedMenuLink.innerText;
    clonedMenuLink.innerText = `${translation.mobile_menu_see_products} ${categoryName}`;
    clonedMenuLink.classList.add('added-category-link');
    li.querySelector('a').after(toggleSubMenu);
    const subMenu = li.querySelector('ul.sub-menu');
    if (subMenu) {
      li.querySelector('ul.sub-menu').after(clonedMenuLink);
    }
  });


  Array.from(mobileMenu.querySelectorAll('.small li.top-dropdown-link')).forEach((li) => {
    li.parentNode.removeChild(li);
  });


  Array.from(document.getElementsByClassName('toggle-mobile-menu')).forEach((link) => {
    link.addEventListener('click', () => {
      document.body.classList.remove('open-mini-wishlist');
      document.body.classList.remove('open-mini-cart');
      document.body.classList.remove('open-search');
      document.body.classList.remove('open-search-menu');
      document.body.classList.toggle('open-mobile-menu');
    });
  });


  Array.from(document.getElementsByClassName('mobile-toggle-sub-menu')).forEach((link) => {
    const target = link;
    const parentEl = link.parentNode;

    link.addEventListener('click', () => {
      parentEl.classList.toggle('open');
      if (parentEl.classList.contains('open')) {
        target.innerText = '–';
      } else {
        target.innerText = '+';
      }
    });
  });


  Array.from(mobileMenu.querySelectorAll('.large ul.menu > li > ul > li > a')).forEach((link) => {
    const parentEl = link.parentNode;
    const button = parentEl.querySelector('button.mobile-toggle-sub-menu');

    if (!link.classList.contains('added-category-link')) {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        parentEl.classList.toggle('open');
        if (parentEl.classList.contains('open')) {
          button.innerText = '-';
        } else {
          button.innerText = '+';
        }
      });
    }
  });
}


const initMobileSearch = () => {
  const toggleSearchButton = document.querySelector('.header .mobile-icons .toggle-search-menu');

  if (!toggleSearchButton) {
    return;
  }

  toggleSearchButton.addEventListener('click', () => {
    document.body.classList.remove('open-mini-wishlist');
    document.body.classList.remove('open-mini-cart');
    document.body.classList.remove('open-search');
    document.body.classList.remove('open-mobile-menu');
    document.body.classList.toggle('open-search-menu');

    if (!document.body.classList.contains('open-search-menu')) {
      const searchForm = document.querySelector('.mobile-search-wrapper input.search-field');
      if (searchForm) {
        searchForm.value = '';
        searchForm.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  });
};
initMobileSearch();


const initNewMobileMenu = () => {
  const newMobileMenu = document.getElementById('new-mobile-menu');

  if (!newMobileMenu) {
    return;
  }


  Array.from(document.getElementsByClassName('toggle-mobile-menu')).forEach((link) => {
    link.addEventListener('click', () => {
      document.body.classList.remove('open-mini-wishlist');
      document.body.classList.remove('open-mini-cart');
      document.body.classList.remove('open-search');
      document.body.classList.remove('open-search-menu');
      document.body.classList.toggle('open-mobile-menu');
    });
  });


  const subMenuItems = newMobileMenu.querySelectorAll('.menu-item-has-children');
  subMenuItems.forEach((group) => {
    const firstLink = group.querySelector('a');
    firstLink.addEventListener('click', (event) => {
      event.preventDefault();
      firstLink.parentNode.classList.toggle('open-sub-menu');
    });
  });


  const langSwitcherContainer = newMobileMenu.querySelector('.menu-country-currency-selector');
  const toggleLangSwitcher = langSwitcherContainer.querySelector('.toggle-menu-lang-selector');

  toggleLangSwitcher.addEventListener('click', (event) => {
    event.preventDefault();
    langSwitcherContainer.classList.toggle('open');
  });
};
initNewMobileMenu();
